// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {ButtonLink} from 'sail/Button';
import {useAccount, useOverlay, useArticle} from 'docs/data';
import {VSCodeButton} from 'docs/shell/sidebar/xray/VSCodeButton';
import {XRayOverlayContainer} from 'docs/shell/sidebar/xray/XRayOverlayContainer';

import './Partial.scss';
import {createStripeInternalUrl} from 'docs/util';

type PartialProps = {|
  file: string,
  variables: {[key: string]: any},
  className?: string,
  children: React.Node,
|};

const renderVars = (variables) => (
  <ul className="Partial-variables">
    {Object.entries(variables).map(([key, value]) => (
      <li key={key}>
        <b>{key}: </b>
        <code>{JSON.stringify(value)}</code>
      </li>
    ))}
  </ul>
);

export const Partial = ({
  className,
  file,
  variables,
  children,
}: PartialProps) => {
  const {account} = useAccount();
  const {article} = useArticle();
  const [overlays] = useOverlay();

  if (!account.xray || !overlays.partials || !article.xray) {
    return children || null;
  }

  const href = createStripeInternalUrl('github', {
    root: 'docs/content/',
    filename: file,
  });

  const actions = (
    <>
      <Box className="Partial-toolbar" flex={{direction: 'row'}}>
        <VSCodeButton path={file} />
        <ButtonLink
          label="View on GitHub"
          href={href}
          icon="external"
          iconPosition="right"
          target="_blank"
        />
      </Box>

      {variables && renderVars(variables)}
    </>
  );

  return (
    <XRayOverlayContainer
      icon="document"
      title={`partial: ${file}`}
      className="Partial"
      actions={actions}
    >
      {children}
    </XRayOverlayContainer>
  );
};
